import { render, staticRenderFns } from "./UpdatePrompt.vue?vue&type=template&id=1237f868&lang=html"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports